export default __webpack_public_path__ + "static/media/school-bus.ab0660c4.png";